import styled, { css } from "styled-components";
import { type PositionProps, position } from "styled-system";
import { EcoTagType } from "../../types/CommonTypes";

const Tag = styled.span<PositionProps>`
    display: inline-block;
    font-family: ${({ theme }) => theme.fontFamily.bold};
    font-size: 1.2rem;
    text-transform: uppercase;
    white-space: nowrap;
    ${position};
`;

export const Eco = styled(Tag)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 50px;
    height: 50px;
    font-style: italic;
    text-align: center;
    color: #8f9496;
    white-space: normal;
`;

export const Motorisation = styled(Tag)<{ type: EcoTagType }>`
    margin: -5px;
    padding: 0 5px;
    font-style: italic;
    color: ${({ type, theme }) => (type === EcoTagType.FuelCell ? theme.color.fuelCell : theme.color.hybrid)};
`;

export const Outline = styled.span`
    display: inline-block;
    padding: 3px 11px;
    font-size: 1.3rem;
    line-height: 2rem;
    ${({ theme }) => css`
        font-family: ${theme.fontFamily.book};
        color: ${theme.color.grey5};
        border: 1px solid ${theme.color.grey5};
        border-radius: 4px;
    `};
`;
